// Mock-up of the uploaded school logo on the polo's left chest.
// Position calibrated from the original crested sample photo (polo-front-crested.jpg).
const CHEST = { left: "56%", top: "40%", width: "13%", height: "9%" };

export const LogoMockup = ({ previewUrl, isPdf, schoolName }) => (
  <div data-testid="school-logo-mockup" className="grid grid-cols-2 gap-3">
    <figure>
      <div className="relative overflow-hidden aspect-[3/4] bg-ink/5">
        <img
          src="/products/polo-front.jpg"
          alt="Polo mock-up"
          className="w-full h-full object-cover"
        />
        <div
          className="absolute flex items-center justify-center"
          style={CHEST}
          data-testid="school-logo-mockup-slot"
        >
          {previewUrl && !isPdf ? (
            <img
              src={previewUrl}
              alt="Your school logo"
              data-testid="school-logo-mockup-image"
              className="max-w-full max-h-full object-contain mix-blend-multiply"
            />
          ) : (
            <span
              data-testid="school-logo-mockup-placeholder"
              className="w-full h-full border border-dashed border-oxblood/70 bg-white/40 flex items-center justify-center text-center font-mono text-[7px] leading-tight uppercase tracking-[0.1em] text-oxblood px-1"
            >
              {schoolName ? schoolName : "Your logo"}
            </span>
          )}
        </div>
      </div>
      <figcaption className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-mutedink">
        Your logo · left chest
        {isPdf && " · PDF shown as placement box"}
      </figcaption>
    </figure>
    <figure>
      <div className="overflow-hidden aspect-[3/4] bg-ink/5">
        <img
          src="/products/polo-front-example.jpg"
          alt="Example of a stitched school crest"
          data-testid="school-logo-example"
          className="w-full h-full object-cover"
        />
      </div>
      <figcaption className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-mutedink">
        Example · stitched crest
      </figcaption>
    </figure>
  </div>
);
